import { render, staticRenderFns } from "./import-mapping-and-analysis.vue?vue&type=template&id=f8a868f4"
import script from "./import-mapping-and-analysis.vue?vue&type=script&lang=js"
export * from "./import-mapping-and-analysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports